import { api } from "@lumberset/api-client";
import { HelpArticleEditor, staffArticlesQuery } from "@lumberset/support-ui";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../../components/crumbs";

export const Route = createFileRoute("/_app/help/articles/$id")({ component: EditArticle });

function EditArticle() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data } = useQuery(staffArticlesQuery(api));
  const categories = [...new Set((data?.articles ?? []).map((article) => article.category))];

  return (
    <>
      <Crumbs
        trail={[{ label: "Help articles", to: "/help/articles" }, { label: "Edit article" }]}
      />
      <HelpArticleEditor
        api={api}
        articleId={id}
        categories={categories}
        onDeleted={() => navigate({ to: "/help/articles" })}
      />
    </>
  );
}
